export const SET_REPORT_LOADER = 'SET_REPORT_LOADER';
export const FETCH_CHARGERS_HISTORY_DATA = 'FETCH_CHARGERS_HISTORY_DATA'
export const CLEAR_CHARGING_HISTORY_LIST_DATA = 'CLEAR_CHARGING_HISTORY_LIST_DATA'
export const SET_CHARGING_HISTORY_LIST_TABLE_PROPS = 'SET_CHARGING_HISTORY_LIST_TABLE_PROPS'
export const FETCH_CHARGER_LOGS_DATA = 'FETCH_CHARGER_LOGS_DATA'
export const SET_CHARGER_LOGS_LIST_TABLE_PROPS = 'SET_CHARGER_LOGS_LIST_TABLE_PROPS'
export const CLEAR_CHARGER_LOGS_LIST_DATA = 'CLEAR_CHARGER_LOGS_LIST_DATA'
export const FETCH_EXCEPTION_LOGS_DATA = 'FETCH_EXCEPTION_LOGS_DATA'
export const SET_EXCEPTION_LOGS_LIST_TABLE_PROPS = 'SET_EXCEPTION_LOGS_LIST_TABLE_PROPS'
export const CLEAR_EXCEPTION_LOGS_LIST_DATA = 'CLEAR_EXCEPTION_LOGS_LIST_DATA'

export const SET_CHARGER_LOGS_LIST_REQUEST_HASH = 'SET_CHARGER_LOGS_LIST_REQUEST_HASH'
export const SET_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION';

export const FETCH_SESSION_HISTORY_DATA = 'FETCH_SESSION_HISTORY_DATA'
export const CLEAR_SESSION_HISTORY_LIST_DATA = 'CLEAR_SESSION_HISTORY_LIST_DATA'
export const SET_SESSION_HISTORY_LIST_TABLE_PROPS = 'SET_SESSION_HISTORY_LIST_TABLE_PROPS'
export const SET_SESSION_HISTORY_LIST_REQUEST_HASH = 'SET_SESSION_HISTORY_LIST_REQUEST_HASH'
export const SET_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION';


export const FETCH_STATUS_HISTORY_DATA = 'FETCH_STATUS_HISTORY_DATA'
export const SET_STATUS_HISTORY_LIST_REQUEST_HASH = 'SET_STATUS_HISTORY_LIST_REQUEST_HASH'
export const SET_STATUS_HISTORY_LIST_TABLE_PROPS = 'SET_STATUS_HISTORY_LIST_TABLE_PROPS'
export const SET_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION'
export const CLEAR_STATUS_HISTORY_LIST_DATA = 'CLEAR_STATUS_HISTORY_LIST_DATA'

export const FETCH_STOP_REASON_ENUMS_ENABLED = 'FETCH_STOP_REASON_ENUMS_ENABLED'
export const FETCH_STOP_REASON_ENUMS_APPLICABLE = 'FETCH_STOP_REASON_ENUMS_APPLICABLE'


export const FETCH_INVENTORY_PARAM_HISTORY_REPORT_DATA = 'FETCH_INVENTORY_PARAM_HISTORY_REPORT_DATA'
export const SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER = 'SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER'
export const SET_INVENTORY_PARAM_HISTORY_REPORT_REQUEST_HASH = 'SET_INVENTORY_PARAM_HISTORY_REPORT_REQUEST_HASH'
export const CLEAR_INVENTORY_PARAM_HISTORY_REPORT_DATA = 'CLEAR_INVENTORY_PARAM_HISTORY_REPORT_DATA'
export const SET_INVENTORY_PARAM_HISTORY_REPORT_TABLE_PROPS = 'SET_INVENTORY_PARAM_HISTORY_REPORT_TABLE_PROPS'


export const FETCH_INVENTORY_PARAM_LATEST_LOGS_REPORT_DATA = 'FETCH_INVENTORY_PARAM_LATEST_LOGS_REPORT_DATA'
export const SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_REQUEST_HASH = 'SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_REQUEST_HASH'
export const SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_TABLE_PROPS = 'SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_TABLE_PROPS'

export const FETCH_INVENTORY_PARAM_CHANGE_LOGS_REPORT_DATA = 'FETCH_INVENTORY_PARAM_CHANGE_LOGS_REPORT_DATA'
export const SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_REQUEST_HASH = 'SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_REQUEST_HASH'
export const SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_TABLE_PROPS = 'SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_TABLE_PROPS'